import axios, { AxiosInstance } from 'axios';

const ENDPOINT = process.env.NEXT_PUBLIC_CONTENT_API_ENDPOINT || 'https://api-content.web-api.dom.ru';

const contentRequest = (accessToken?: string, headers = {}): AxiosInstance => {
    const initHeaders: Record<string, string> = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    };

    if (accessToken) {
        initHeaders['Authorization'] = `Bearer ${accessToken}`;
    }

    return axios.create({
        baseURL: ENDPOINT,
        headers: { ...initHeaders, ...headers },
    });
};

export default contentRequest;
